import React from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as LogoBonvoy } from '../../assets/bonvoy.svg'
import styled, { css } from 'styled-components/macro'
import { rem } from 'polished'
import { ROUTES } from '../../constants'

const Logo = ({ light, ...props }) => {
  const { QUESTIONS } = ROUTES
  return (
    <LogoContainer {...props}>
      <Layout>
        <a href={QUESTIONS}>
          <Bonvoy />
        </a>
      </Layout>
    </LogoContainer>
  )
}

Logo.propTypes = {
  light: PropTypes.bool,
}
export default Logo

const Layout = styled.div(
  () => css`
    position: relative;
    min-width: ${rem(156)};
  `,
)
const Bonvoy = styled(LogoBonvoy)`
  ${() => css`
    width: 100%;
    position: relative;
  `}
`
const LogoContainer = styled.div(
  ({ theme }) => css`
    width: 213px;
    margin: 0 auto;
    max-width: 36.8%;
    display: flex;

    ${theme.media.md`
      min-width: ${rem(213)};
    `};

    ${theme.media.xl`
      /*margin-bottom: ${theme.space(6.5)};*/
    `};

    z-index: 2;
  `,
)
